import { render, staticRenderFns } from "./registerApplication.vue?vue&type=template&id=b0284432&scoped=true"
import script from "./registerApplication.vue?vue&type=script&lang=js"
export * from "./registerApplication.vue?vue&type=script&lang=js"
import style0 from "./registerApplication.vue?vue&type=style&index=0&id=b0284432&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0284432",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0284432')) {
      api.createRecord('b0284432', component.options)
    } else {
      api.reload('b0284432', component.options)
    }
    module.hot.accept("./registerApplication.vue?vue&type=template&id=b0284432&scoped=true", function () {
      api.rerender('b0284432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/registerApplication.vue"
export default component.exports